import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {MsgrService} from '../../services/msgr.service';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

/**
 * Alarmes affichées sur le tableau de bord. Le backend renvoie toute la
 * liste ; la coupe est ici, et sert aussi à équilibrer la hauteur de la
 * carte avec la colonne des officiers de service.
 */
const ALARM_COUNT = 5;

@Component({
    selector: 'app-last-msgr',
    templateUrl: './last-msgr.component.html',
    styleUrls: ['./last-msgr.component.css'],
    standalone: false
})
export class LastMsgrComponent implements OnInit, OnDestroy {
  alarms: any[] = [];
  loading = true;

  @Output()
  contentAvailable = new EventEmitter<boolean>();

  subscription: Subscription;

  constructor(private msgrService: MsgrService) {}

  ngOnInit() {
    this.subscription = this.msgrService
      .listenForChange()
      // MsgrService's stream seeds with `null` before the HTTP call resolves
      // (or on the very first subscription, before load() has ever run).
      // That placeholder isn't real data — reacting to it (spinner off,
      // contentAvailable emitted false) races the parent's own initial
      // change-detection pass and can leave the whole section stuck hidden
      // even once the real alarms arrive. Wait for an actual array.
      .pipe(filter((alarms: any[]) => alarms !== null))
      .subscribe((alarms: any[]) => {
        this.alarms = alarms.slice(0, ALARM_COUNT);
        this.loading = false;
        this.contentAvailable.emit(this.alarms.length > 0);
      });
    this.msgrService.load();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
